<div class="box box-info">
  <div class="box-header with-border">
    <h3 class="box-title">
      Change password
      @if (user) {
        <p style="display: inline;">
          : {{ user.first_name }} {{ user.last_name }} ({{ user.email }})
        </p>
      }
    </h3>
  </div>
  <!-- /.box-header -->
  <!-- form start -->
  <form class="form-horizontal" [formGroup]="form">
    <div class="box-body">
      <div class="form-group">
        <label for="inputEmail3" class="col-sm-3 control-label"
          >Old password</label
          >

          <div class="col-sm-9">
            <input
              type="password"
              class="form-control"
              formControlName="old_password"
              placeholder="Old password"
              />
            @if (
              form.controls['old_password'].hasError('required') &&
              (form.controls['old_password'].touched || attemptedSubmit)
              ) {
              <control-message
                message="Old password is required."
              ></control-message>
            }
            @if (
              form.controls['old_password'].hasError('minlength') &&
              (form.controls['old_password'].touched || attemptedSubmit)
              ) {
              <control-message
                message="Old password is too short."
              ></control-message>
            }
          </div>
        </div>
        <div class="form-group">
          <label for="inputPassword3" class="col-sm-3 control-label"
            >New password</label
            >

            <div class="col-sm-9">
              <input
                type="password"
                class="form-control"
                formControlName="new_password"
                placeholder="New password"
                />
              @if (
                form.controls['new_password'].hasError('required') &&
                (form.controls['new_password'].touched || attemptedSubmit)
                ) {
                <control-message
                  message="Password is required."
                ></control-message>
              }
              @if (
                form.controls['new_password'].hasError('minlength') &&
                (form.controls['new_password'].touched || attemptedSubmit)
                ) {
                <control-message
                  message="new Password is too short."
                ></control-message>
              }
            </div>
          </div>
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-3 control-label"
              >Confirm new password</label
              >

              <div class="col-sm-9">
                <input
                  type="password"
                  class="form-control"
                  formControlName="confirm_password"
                  placeholder="Confirm password"
                  />
                @if (
                  form.controls['confirm_password'].hasError('required') &&
                  (form.controls['confirm_password'].touched || attemptedSubmit)
                  ) {
                  <control-message
                    message="Confirm password is required."
                  ></control-message>
                }
                @if (
                  form.controls['confirm_password'].value !=
                  form.controls['new_password'].value &&
                  (form.controls['confirm_password'].touched || attemptedSubmit)
                  ) {
                  <control-message
                    message="Passwords don't match."
                  ></control-message>
                }
                @if (
                  form.controls['confirm_password'].hasError('minlength') &&
                  (form.controls['confirm_password'].touched || attemptedSubmit)
                  ) {
                  <control-message
                    message="Confirm password is too short."
                  ></control-message>
                }
              </div>
            </div>
          </div>
          <!-- /.box-body -->
          <div class="box-footer">
            <div class="box-footer">
              <button
                type="submit"
                (click)="submitForm()"
                class="btn btn-info pull-right"
                >
                Change password
              </button>
            </div>
          </div>
          <!-- /.box-footer -->
        </form>
      </div>
